import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import GalleryHero from './components/GalleryHero';
import ProjectsGrid from './components/ProjectsGrid';

const GalleryPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <GalleryHero />
        <ProjectsGrid />
      </main>
      <Footer />
    </div>
  );
};

export default GalleryPage;
